/**
 * @param {NewsItem} data
 * @returns {string}
 */
export function newsItemTemplate(data) {
  const badgeColor = (/** @type {string} */ tag) => {
    switch (tag) {
      case 'Credit Cards':
        return 'rgba(0, 34, 68, 0.25)'
      case 'Loans':
        return 'rgba(130, 130, 130, 0.25)'
      case 'Money':
        return 'rgba(99, 206, 77, 0.25)'
      case 'Debt':
        return 'rgba(77, 79, 83, 0.3)'
      case 'Debt Relief':
        return 'rgba(99, 206, 77, 0.5)'
      default:
        return '#eee'
    }
  }

  const itemPath = `${data.Category}/${data.secondSlug ? `${data.secondSlug}/` : ''}${data.slug}`
  return `
      <div class="turbodebt-news-article swiper-slide">
        <img
          class="turbodebt-news-image"
          src="${data.coverImage.data.attributes.url}"
          alt="${data.coverImage.data.attributes.alternativeText}"
        />
        <div class="turbodebt-news-container">
          <div
            class="turbodebt-news-tag"
            style="background-color:${badgeColor(data.tag)}"
          >
            ${data.tag}
          </div>
          <div class="turbodebt-news-headline">
           <a href="https://www.turbodebt.com/${itemPath}">${data.title}</a>
          </div>
          <div class="turbodebt-news-excerpt">${data.excerpt}</div>
        </div>
      </div>
    `
}
